export const MATERNITY_BOOKLET_URL =
  'https://pf2-public-patient-portal-resources.s3.us-east-2.amazonaws.com/KindbodyMaternityBooklet.pdf';
